// 🔧 category_generator.js
// ✅ Purpose: Generates industry-specific categories for the LGV Seed Engine
// ✅ Features:
// - Creates realistic category templates for seeded events
// - Starts with Car Show categories
// - Includes descriptions and display order
// - Future-ready for Art Show, Pet Show, School Election, Festival, and other industries
// - Keeps category generation separate from Firestore writes
// - Fully block-commented for clarity and future devs
import { getIndustryTemplate } from "../industries";

export const generateCategoriesForIndustry = ({
  industryKey = "car_show",
} = {}) => {
  const industry =
    getIndustryTemplate(
      industryKey
    );

  if (!industry?.key) {
    throw new Error(
      `Experience Factory industry "${industryKey}" is not registered.`
    );
  }

  const sourceCategories =
    industry.categories || [];

  if (!sourceCategories.length) {
    throw new Error(
      `Experience Factory industry "${industryKey}" has no category templates.`
    );
  }

  const namedCategories = sourceCategories.map((category, index) => ({
    ...category,
    displayOrder: index + 1,
    demoSeed: true,
  }));

  // Seed the same real unnamed category used by optional-category registration.
  // Named industry categories stay unchanged; the hidden default remains selectable.
  return [...namedCategories, {
    name: "",
    title: "",
    isDefault: true,
    displayOrder: namedCategories.length + 1,
    demoSeed: true,
  }];
};
